import React from 'react';
import { portfolioData } from '../mock';
import { useReveal } from '../hooks/useReveal';

const SkillGroup = ({ title, skills, index }) => {
  const [ref, visible] = useReveal();
  return (
    <div
      ref={ref}
      data-testid={`skill-group-${index}`}
      className={`reveal ${visible ? 'is-visible' : ''} py-8 border-b border-[hsl(var(--rule))] grid grid-cols-12 gap-4 sm:gap-8`}
      style={{ transitionDelay: `${index * 60}ms` }}
    >
      <div className="col-span-12 sm:col-span-4 mono text-xs text-[hsl(var(--foreground-faint))] uppercase tracking-wider pt-1">
        {title}
      </div>
      <div className="col-span-12 sm:col-span-8 flex flex-wrap gap-x-5 gap-y-2">
        {skills.map((s, i) => (
          <span
            key={i}
            className="text-lg sm:text-xl text-[hsl(var(--foreground))] hover:text-[hsl(var(--accent))] transition-colors cursor-default"
          >
            {s}
            {i < skills.length - 1 && (
              <span className="text-[hsl(var(--foreground-faint))] ml-5">·</span>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

const Skills = () => {
  const groups = [
    { title: 'languages', skills: portfolioData.skills.languages },
    { title: 'frameworks', skills: portfolioData.skills.frameworks },
    { title: 'cloud & infra', skills: portfolioData.skills.cloud },
    { title: 'databases', skills: portfolioData.skills.databases },
    { title: 'tools', skills: portfolioData.skills.tools },
  ];

  return (
    <section
      id="skills"
      data-testid="skills-section"
      className="py-28 sm:py-36 px-5 sm:px-8 lg:px-12 border-t border-[hsl(var(--rule))]"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16 mb-14">
          <div className="lg:col-span-4">
            <div className="section-label mb-6">
              <span>03 / toolkit</span>
            </div>
            <h2 className="display text-4xl sm:text-5xl leading-tight">
              The stack
              <br />
              I reach for.
            </h2>
          </div>
          <div className="lg:col-span-8 lg:pt-3">
            <p className="text-xl text-[hsl(var(--foreground-muted))] leading-relaxed max-w-2xl">
              A mix of what I know deeply and what I keep picking up. I care less about the brand of a tool and more about whether it gets out of the way.
            </p>
          </div>
        </div>

        <div>
          {groups.map((g, i) => (
            <SkillGroup key={g.title} title={g.title} skills={g.skills} index={i} />
          ))}
        </div>

        <div className="mt-12 pt-8">
          <div className="mono text-xs text-[hsl(var(--foreground-faint))] uppercase tracking-wider mb-5">
            // areas of focus
          </div>
          <div className="flex flex-wrap gap-2">
            {portfolioData.expertise.map((e, i) => (
              <span
                key={i}
                data-testid={`expertise-${i}`}
                className="mono text-xs px-3 py-1.5 border border-[hsl(var(--rule))] rounded-full hover:border-[hsl(var(--accent))] hover:text-[hsl(var(--accent))] transition-colors cursor-default"
              >
                {e}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
